import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TransportOption, TransportOptionLimitSchedule } from '../../transport-options.model';
import { DialogService } from '@sdbn/common';

@Component({
  selector: 'app-transport-option-editor-limits',
  templateUrl: './transport-option-editor-limits.component.html',
  styleUrls: ['./transport-option-editor-limits.component.scss']
})
export class TransportOptionEditorLimitsComponent {

  @Input() transportOption?: TransportOption;

  @Output() changed = new EventEmitter();

  constructor(
    private dialogService: DialogService
  ) { }

  public addLimitSchedule(): void {
    if (this.transportOption) {
      const newSchedule = new TransportOptionLimitSchedule();
      this.transportOption.limitSchedules.push(newSchedule);
      this.changed.emit();
    }

  }

  public removeLimitSchedule(schedule: TransportOptionLimitSchedule): void {
    if (this.transportOption) {
      this.dialogService.showConfirm(
        'tmc-yard.control.ui.transport-option-administration.confirm-remove-limit-schedule-title',
        'tmc-yard.control.ui.transport-option-administration.confirm-remove-limit-schedule-message'
      ).afterClosed().subscribe(confirmed => {
        if (confirmed) {
          const index = this.transportOption!.limitSchedules.indexOf(schedule);
          if (index > -1) {
            this.transportOption!.limitSchedules.splice(index, 1);
            this.changed.emit();
          }
        }
      });

    }
  }

}
